import { render, staticRenderFns } from "./VirtualVDataTable.vue?vue&type=template&id=29a91f6a&scoped=true"
import script from "./VirtualVDataTable.vue?vue&type=script&lang=js"
export * from "./VirtualVDataTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualVDataTable.vue?vue&type=style&index=0&id=29a91f6a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a91f6a",
  null
  
)

export default component.exports